/**
 * @file Custom print description notice/purchase modal.
 */

import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import withModal from '../global/modal/withModal';
import { CUSTOM_PRINT_DESC_MODAL } from '../../constants/modals';
import Button from '../global/Button';
import { formatPriceForDisplay } from '../../util/format-money';
import {
  getAlbumCustomPrintName,
  getAlbumCustomPrintPreviewImageUrl,
  getAlbumCustomPrintPrice,
} from '../../util/custom-prints';

const propTypes = {
  onRequestClose: PropTypes.func,
  onCustomPrintPurchase: PropTypes.func.isRequired,
  albumCustomPrint: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  shouldDiscount: PropTypes.bool,
};

const CustomPrintDescription = ({
  onRequestClose,
  onCustomPrintPurchase,
  albumCustomPrint,
  shouldDiscount,
}) => {
  const albumCustomPrintName = getAlbumCustomPrintName(albumCustomPrint);
  const price = getAlbumCustomPrintPrice(albumCustomPrint);
  const discountPrice = getAlbumCustomPrintPrice(albumCustomPrint, true);
  const finalPrice = shouldDiscount && !!discountPrice ? discountPrice : price;
  const albumCustomPrintPreviewImageUrl =
    getAlbumCustomPrintPreviewImageUrl(albumCustomPrint);

  return (
    <div className="p-1">
      <p>
        Pick your{' '}
        <strong>{get(albumCustomPrint, 'custom_print.photos_no')}</strong>{' '}
        favorite photos and get your custom-designed{' '}
        {albumCustomPrintName.toLowerCase()}!
      </p>

      {albumCustomPrintPreviewImageUrl && (
        <p>
          <img
            src={albumCustomPrintPreviewImageUrl}
            alt={`Sample ${albumCustomPrintName}`}
          />
          <span className="text-sm d-block text-center mt-1">
            Sample {albumCustomPrintName}.
            <em className="d-block text-faded text-xs">
              You&rsquo;ll be able to select your photos after purchase.
            </em>
          </span>
        </p>
      )}

      <Button
        btnBlock
        className="mt-3"
        onClick={() => {
          onCustomPrintPurchase();
          onRequestClose();
        }}
        btnStyle="secondary"
      >
        Buy now ($
        {formatPriceForDisplay(finalPrice, true)})
      </Button>

      <div className="mt-1 text-center">
        <Button btnBlock btnStyle="link" onClick={onRequestClose}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

const CustomPrintDescriptionModal = withModal(CustomPrintDescription, {
  name: CUSTOM_PRINT_DESC_MODAL,
  size: 'sm',
  hideHeader: true,
});

CustomPrintDescription.propTypes = propTypes;
CustomPrintDescriptionModal.propTypes = propTypes;

export { CustomPrintDescription };

export default CustomPrintDescriptionModal;
